import { render, staticRenderFns } from "./AssetsDetailsRegister.vue?vue&type=template&id=a65482e8"
import script from "./AssetsDetailsRegister.vue?vue&type=script&lang=js"
export * from "./AssetsDetailsRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports